// ホームページ
import { Header } from '../components/header.js';
import { Footer } from '../components/footer.js';
import { getStats } from '../utils/download-stats.js';

export function HomePage() {
  // 統計情報を非同期で取得してDOMを更新
  getStats().then(stats => {
    const totalElement = document.getElementById('total-downloads');
    const uniqueUsersElement = document.getElementById('unique-users');

    if (totalElement) {
      totalElement.textContent = stats.totalDownloads + '件以上';
    }
    if (uniqueUsersElement) {
      uniqueUsersElement.textContent = stats.uniqueUsers + '社以上';
    }
  }).catch(error => {
    console.error('Failed to load stats:', error);
  });
  const whitepapers = [
    {
      id: 'wp01',
      title: '「検討します」を「申し込みます」に変える魔法の一言',
      description: '購入検討者の心理を理解し、クロージング率を3倍にする実践的テクニック',
      thumbnail: '/images/wp01-thumb.png',
      downloadCount: '1,234',
      pages: 10
    },
    {
      id: 'wp02',
      title: '初回面談30分で専任媒介を獲得する面談シート',
      description: '時間配分から質問の流れまで、成功率87%の面談手法を完全公開',
      thumbnail: '/images/wp02-thumb.png',
      downloadCount: '987',
      pages: 12
    },
    {
      id: 'wp03',
      title: '年収を聞かずに予算を把握する7つの質問術',
      description: 'お客様との関係を壊さずに、正確な予算を把握する心理テクニック',
      thumbnail: '/images/wp03-thumb.png',
      downloadCount: '856',
      pages: 11
    }
  ];

  return `
    ${Header()}

    <main>
      <section class="hero">
        <div class="container">
          <h2>ポータル反響からの成約率向上をサポート！</h2>
          <p class="lead">お客様との信頼関係を深め、確実な成約につなげる<br>実践的ノウハウをご紹介</p>
          <a href="/master" class="hero-cta">反響成約マスターを詳しく見る</a>
        </div>
      </section>

      <!-- 活動実績バナー -->
      <section class="activity-stats">
        <div class="container">
          <div class="stats-grid">
            <div class="stat-item">
              <div class="stat-number" id="total-downloads">390件以上</div>
              <div class="stat-label">ダウンロード実績</div>
              <div class="stat-update">増加中</div>
            </div>
            <div class="stat-item">
              <div class="stat-number">18本</div>
              <div class="stat-label">公開中レポート</div>
              <div class="stat-update">+3本追加 (9/15)</div>
            </div>
            <div class="stat-item">
              <div class="stat-number">20記事</div>
              <div class="stat-label">実践ノウハウ公開中</div>
              <div class="stat-update">すぐ使える</div>
            </div>
            <div class="stat-item">
              <div class="stat-number" id="unique-users">95社以上</div>
              <div class="stat-label">導入企業・団体</div>
              <div class="stat-update">全国で活用中</div>
            </div>
          </div>
        </div>
      </section>

      <!-- 更新履歴タイムライン -->
      <section class="updates-section">
        <div class="container">
          <h2 class="section-title">🔥 最新アップデート</h2>
          <div class="updates-timeline">
            <div class="timeline-item new">
              <div class="timeline-date">2026.09.15</div>
              <div class="timeline-content">
                <span class="badge new-badge">NEW</span>
                <h3>新レポート3本追加公開</h3>
                <ul>
                  <li><a href="/master/download/wp17">内見中やってはいけないNG行動ワースト10</a></li>
                  <li><a href="/master/download/wp18">購入決断を1週間早める緊急性演出法</a></li>
                  <li><a href="/master/download/wp27">初対面で信頼を築く話法</a></li>
                </ul>
              </div>
            </div>

            <div class="timeline-item">
              <div class="timeline-date">2026.06.30</div>
              <div class="timeline-content">
                <h3>新レポート3本追加公開</h3>
                <ul>
                  <li><a href="/master/download/wp13">ポータルからの反響を来店に繋げる返信テンプレート集</a></li>
                  <li><a href="/master/download/wp14">購入客が本当に知りたい10の質問と模範回答</a></li>
                  <li><a href="/master/download/wp15">信頼を勝ち取る車内トーク術</a></li>
                </ul>
              </div>
            </div>

            <div class="timeline-item">
              <div class="timeline-date">2026.04.13</div>
              <div class="timeline-content">
                <h3>新レポート3本追加公開</h3>
                <ul>
                  <li><a href="/master/download/wp10">内見3件以内で決める！事前ヒアリング完全ガイド</a></li>
                  <li><a href="/master/download/wp11">購入申込書の記入率を80%に上げる心理テクニック</a></li>
                  <li><a href="/master/download/wp12">仲介手数料半額と言われた時の価値の伝え方</a></li>
                </ul>
              </div>
            </div>

            <div class="timeline-item">
              <div class="timeline-date">2026.02.02</div>
              <div class="timeline-content">
                <h3>新レポート3本追加公開</h3>
                <ul>
                  <li><a href="/master/download/wp07">「他社も見ています」と言われた時の切り返し話法20選</a></li>
                  <li><a href="/master/download/wp08">内見後に音信不通になった客を復活させる3通のLINE</a></li>
                  <li><a href="/master/download/wp09">ローン事前審査を初回面談で通す5ステップ</a></li>
                </ul>
              </div>
            </div>

            <div class="timeline-item milestone">
              <div class="timeline-date">2026.01.15</div>
              <div class="timeline-content">
                <span class="badge milestone-badge">達成</span>
                <h3>ダウンロード数500名突破！</h3>
                <p>全国の不動産営業担当者にご活用いただいています</p>
              </div>
            </div>

            <div class="timeline-item">
              <div class="timeline-date">2025.10.06</div>
              <div class="timeline-content">
                <h3>新レポート3本追加公開</h3>
                <ul>
                  <li><a href="/master/download/wp04">購入検討者の心理段階別アプローチ法</a></li>
                  <li><a href="/master/download/wp05">成約率を上げる物件案内チェックリスト</a></li>
                  <li><a href="/master/download/wp06">購入申込を獲得する交渉術</a></li>
                </ul>
              </div>
            </div>

            <div class="timeline-item milestone">
              <div class="timeline-date">2025.10.04</div>
              <div class="timeline-content">
                <span class="badge milestone-badge">達成</span>
                <h3>ダウンロード数100名突破！</h3>
                <p>多くの不動産営業担当者の方にご活用いただいています</p>
              </div>
            </div>

            <div class="timeline-item">
              <div class="timeline-date">2025.09.22</div>
              <div class="timeline-content">
                <h3>反響成約ラボ 記事20本公開</h3>
                <p>初回面談〜クロージングまで体系的に網羅</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- Coming Soon -->
      <section class="coming-soon-section">
        <div class="container">
          <h2 class="section-title">📅 Coming Soon</h2>
          <div class="coming-soon-grid">
            <div class="soon-card">
              <span class="soon-badge">近日公開</span>
              <h3>フォローアップ・長期戦略編</h3>
              <p>検討期間を短縮し、確実に成約へ導く継続的アプローチ</p>
            </div>
            <div class="soon-card">
              <span class="soon-badge">準備中</span>
              <h3>セミナー参加者限定特典</h3>
              <p>セミナー参加者のみがアクセスできる限定レポート</p>
            </div>
            <div class="soon-card">
              <span class="soon-badge">企画中</span>
              <h3>実践事例集</h3>
              <p>実際に成果を出した営業担当者の成功事例を公開</p>
            </div>
          </div>
        </div>
      </section>

      <section class="whitepapers">
        <div class="container">
          <h2>実践的ノウハウを無料公開</h2>
          <div class="whitepaper-grid">
            ${whitepapers.map(wp => `
              <a href="/master/download/${wp.id}" class="download-card-link">
                <div class="download-card">
                  <div class="download-card-image">
                    <img src="${wp.thumbnail}" alt="${wp.title}">
                  </div>
                  <div class="download-card-content">
                    <h3 class="download-card-title">${wp.title}</h3>
                    <p class="download-card-description">${wp.description}</p>
                    <div class="download-card-footer">
                      <span class="page-count">PDF資料</span>
                      <span class="download-btn">無料ダウンロード →</span>
                    </div>
                  </div>
                </div>
              </a>
            `).join('')}
          </div>
        </div>
      </section>

      <section class="benefits">
        <div class="container">
          <h2>反響成約で成果を出すための3つのポイント</h2>
          <div class="benefit-list">
            <div class="benefit-item">
              <h3>顧客理解の深化</h3>
              <p>お客様の本音を引き出し、真のニーズを把握する面談術</p>
            </div>
            <div class="benefit-item">
              <h3>信頼関係の構築</h3>
              <p>初回面談から成約まで、段階的に信頼を深める方法</p>
            </div>
            <div class="benefit-item">
              <h3>効果的なクロージング</h3>
              <p>検討中のお客様を確実に成約へ導く実践テクニック</p>
            </div>
          </div>
        </div>
      </section>
    </main>

    ${Footer()}
  `;
}